import Vue from 'vue';
import App from './App.vue';
import store from './store';
import VueSocketIO from 'vue-socket.io';
import router from './router';
import moment from 'moment';
import '@/assets/css/tailwind.css';
import '@/plugins/apexcharts';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: 'http://192.168.88.27:5000',
//   options: {
//     //Options object to pass into SocketIO
//   }
// }));

new Vue({
  store,
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
